import {
  CREATE_INVENTORY_RULE_DATA,
  CREATE_INVENTORY_RULE_REQUEST,
  FETCH_INVENTORY_RULE_DATA_REQUEST,
  FETCH_INVENTORY_RULE_DATA_SUCCESS,
  FETCH_INVENTORY_RULES_DATA_REQUEST,
  FETCH_INVENTORY_RULES_DATA_SUCCESS
} from "../constants/actionTypes";
import { createReducer } from "../utils";

const initialState = {
  inventoryRule: {},
  inventoryRules: {},
  error: "",
  isFetching: false,
  isCreating: false
};

export const inventoryRulesReducer = createReducer(initialState, {
  [FETCH_INVENTORY_RULES_DATA_REQUEST]: (state, payload) => {
    const { page } = payload;
    return {
      ...state,
      inventoryRules: {
        ...state.inventoryRules,
        [page]: {
          isFetching: true,
          rules: []
        }
      }
    };
  },
  [FETCH_INVENTORY_RULES_DATA_SUCCESS]: (state, payload) => {
    const { page, data } = payload;
    return {
      ...state,
      inventoryRules: {
        ...state.inventoryRules,
        [page]: {
          isFetching: false,
          rules: data
        }
      }
    };
  },
  [CREATE_INVENTORY_RULE_REQUEST]: state => {
    return {
      ...state,
      isCreating: true,
      error: ""
    };
  },
  [CREATE_INVENTORY_RULE_DATA]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isCreating: false
    };
  },
  [FETCH_INVENTORY_RULE_DATA_REQUEST]: state => {
    return {
      ...state,
      isFetching: true,
      inventoryRule: {}
    };
  },
  [FETCH_INVENTORY_RULE_DATA_SUCCESS]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: false
    };
  }
});

export default inventoryRulesReducer;
